import { Redirect } from 'expo-router';
import React from 'react';

/** Native-only authenticator success host. Web does not use this route. */
export default function UaePassSuccessWebRoute() {
  return <Redirect href="/welcome" />;
}
